import React from 'react';
import { Box } from '@drivekyte/web-components';
import { PillButton, useMedia } from '@drivekyte/ui';
import { Categories, CategoriesSelectionProps } from './types';

const CategoriesSelection = ({
  activeCategories,
  category,
  onCategoryChange,
}: CategoriesSelectionProps) => {
  const media = useMedia();
  const isMobile = media.xs;
  const categories = activeCategories
    ? [Categories.All, ...activeCategories]
    : Object.values(Categories);

  return (
    <Box
      display="flex"
      justifyContent={isMobile ? 'flex-start' : 'space-around'}
      marginVertical={isMobile ? 'tiny' : 'large'}
    >
      <Box
        maxWidth={isMobile ? '100%' : '800px'}
        overflowX="scroll"
        padding="small"
        style={{ scrollbarWidth: 'none' }}
      >
        {categories.map((value, index) => (
          <PillButton
            variant={value === category ? 'primary' : 'tertiary'}
            key={value + index}
            marginHorizontal="$xSmall"
            onPress={() => onCategoryChange(value)}
          >
            {value}
          </PillButton>
        ))}
      </Box>
    </Box>
  );
};

export default CategoriesSelection;
